<content-block [title]="'Preference.ModeReception.Title' | translate" [headerActions]="contentBlockActions" classList="has-spacer">
	<form [formGroup]="form" *ngIf="form">
		<div class="col-md-4 form-group">
			<div class="cell-title form-label">
				{{ 'Preference.ModeReception.Retour' | translate }}
			</div>
			<ng-container *ngIf="modesReception$ | async as modesReception">
				<ng-select
					labelForId="retour"
					formControlName="retour"
					appendTo="body"
					[class.is-invalid]="form?.controls?.retour.dirty && form?.controls?.retour.invalid"
					[searchable]="true"
					[placeholder]="'Forms.Placeholder.Select' | translate"
					[notFoundText]="'NgSelect.NotFoundText' | translate"
					[typeToSearchText]="'NgSelect.TypeToSearchText' | translate"
					[loadingText]="'NgSelect.LoadingText' | translate"
					[clearAllText]="'NgSelect.ClearAllText' | translate"
					[clearable]="true"
					*ngIf="isEditMode"
				>
					<ng-option *ngFor="let modeReception of modesReception" [value]="modeReception.id">
						{{ modeReception.libelle }}
					</ng-option>
				</ng-select>
			</ng-container>

			<form-control-feedback [field]="form?.controls?.retour"></form-control-feedback>
			<span class="cell-value" *ngIf="!isEditMode">
				{{ modesReceptionPreference?.libelle }}
			</span>
		</div>

		<div class="edit-btns text-end" *ngIf="isEditMode" style="margin-top: 24px">
			<button
				type="button"
				class="btn btn-secondary btn-cancel me-2"
				(click)="cancel()"
				[disabled]="preferenceService.editLoading$ | async"
			>
				{{ 'Actions.Cancel' | translate }}
			</button>
			<button type="button" class="btn btn-primary" (click)="confirm()" [disabled]="preferenceService.editLoading$ | async">
				<loader-button-spinner [isShowButtonSpinner]="preferenceService.editLoading$ | async"></loader-button-spinner>
				{{ 'Actions.Confirm' | translate }}
			</button>
		</div>
	</form>
	<div class="date-modif" *ngIf="!isEditMode && preferenceModeReception?.lastDateModification">
		<p>
			{{
				'Preference.DerniereModification'
					| translate
						: {
								dateModification: preferenceModeReception.lastDateModification | date: 'dd/MM/yyyy',
								heureModification: preferenceModeReception.lastDateModification | date: 'HH',
								minuteModification: preferenceModeReception.lastDateModification | date: 'mm',
								utilisateurModification: preferenceModeReception.lastUtilisateurModification
						  }
			}}
		</p>
	</div>
</content-block>

<ng-template #contentBlockActions>
	<button type="button" class="btn btn-primary" (click)="edit()" *ngIf="allowEdit && !isEditMode" [disabled]="anyEditMode$ | async">
		<span>
			<i class="far fa-pencil"></i>
			<loader-button-spinner [isShowButtonSpinner]="preferenceService.getLoading$ | async"></loader-button-spinner>
			{{ 'Actions.Edit' | translate }}
		</span>
	</button>
</ng-template>
